import { render, staticRenderFns } from "./TeamTwo.vue?vue&type=template&id=7f02c040&scoped=true&lang=pug&"
import script from "./TeamTwo.vue?vue&type=script&lang=js&"
export * from "./TeamTwo.vue?vue&type=script&lang=js&"
import style0 from "./TeamTwo.vue?vue&type=style&index=0&id=7f02c040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f02c040",
  null
  
)

export default component.exports